import { StyleSheet } from "react-native";
import { screenHeight, screenWidth } from "../../../utils/dimensions";
import { colors, fontSizes } from "../../../constants/styles";

export const modalStyles = StyleSheet.create({
  container: {
    width: screenWidth,
    backgroundColor: colors.blackAlpha(0.5),
    height: screenHeight,
    position: "absolute",
  },
  childContainer: { flex: 1 },
});

export const spinnerStyles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});

export const emptyProductListStyles = StyleSheet.create({
  message: {
    flex: 1,
    fontFamily: "HelveticaNeue",
    color: colors.disabledText,
    textAlign: "center",
    fontSize: fontSizes.x14,
    letterSpacing: 0,
    marginTop: 20,
  },
});

export const quantityModifierStyles = StyleSheet.create({
  container: {
    flex: 1,
    paddingRight: 5,
  },
  selectedButtonContainer: {
    flex: 1,
    borderRadius: 8,
    backgroundColor: colors.albaikRed,
    marginBottom: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  unselectedButtonContainer: {
    flex: 1,
    borderRadius: 8,
    backgroundColor: colors.cedar30,
    marginBottom: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  buttonContainer: {
    flex: 1,
    borderRadius: 8,
    backgroundColor: colors.cedar,
    marginBottom: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  buttonText: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
});
